module.exports = __webpack_public_path__ + "img/contactUs_hero_wGradient.9bf21fc8.png";